
/*
 * This entire file and all its contents should not exist, they are relics of the time when everything was written
 * in JS and thus their types reflect the fact that everything was mutated and had extra data hammered into it rather
 * than being composite objects of immutable data.
 * It is also a complete and utter duplicate of a file that lives in /types and I have no idea how that happened,
 * but it did...
 * This has caused us to now have three sets of "OrderStatus" etc, which is a bit of an issue for now
 */

import {OrderLifetime} from "./OrderRecord";

/** @deprecated */
export interface Order {
    code: string;
    quantity: number;
    limit?: number;
    description: string;
    buy: boolean;
}

/** @deprecated */
export interface PlaceOrderRequest extends Order {
    lifetime?: OrderLifetime;
    expiry?: string | null;
}

/** @deprecated */
export interface TfOrder extends Order {
    id: number;
    side: OrderSide;
    portfolioId: number;
    portfolioType: string;
    accountNumber: string;
    accountName: string;
    orderNumber: string;
    externalRef: string;
    description: string;
    created: string;
    updated: string;
    completed?: string;
    lifetime?: OrderLifetime;
    status: OrderStatus;
    closedReason?: CloseReason;
    priceInstruction: string;
    underlying: string;
    filledQuantity: number;
    filledPrice?: number;
    createdBy: CreatedBy;
    tmc: boolean;
    quote?: OrderQuote;
    cvf: number;
}

/** @deprecated */
export interface TmcOrder extends TfOrder {
    tmc: true;
    legs: OrderLeg[];
}

/** @deprecated */
export interface SingleOrder extends TfOrder {
    tmc: false;
    style: string;
    type: OrderType;
    expiry: string;
    strike: number;
    daysToExpiry: number;
}

/** @deprecated */
export enum OrderStatus {
    PENDING = "PENDING",
    WAITING_OPERATOR = "WAITING_OPERATOR",
    ON_MARKET = "ON_MARKET",
    DONE = "DONE"
}

/** @deprecated */
export enum CloseReason {
    FAILED = "FAILED",
    EXPIRED = "EXPIRED",
    FILLED = "FILLED",
    CANCELLED = "CANCELLED",
    REJECTED = "REJECTED"
}

/** @deprecated */
export enum OrderSide {
    BUY = "BUY",
    SELL = "SELL"
}

/** @deprecated */
export enum OrderType {
    PUT = "PUT",
    CALL = "CALL"
}

/** @deprecated */
export interface OrderQuote {
    code: string;
    asAt: string;
    underlyingPrice?: number;
    bid?: number;
    bidLimit: number;
    bidVol?: number;
    offer?: number;
    offerLimit: number;
    offerVol?: number;
    ask?: number;
    askLimit: number;
    theo?: number;
    last?: number;
    mid?: number;
    basisOfQuotation: string;
    tradingState: string;
}

/** @deprecated */
export interface OrderLeg {
    code: string;
    ratio: number;
    side: OrderSide;
    legType: "O" | "E";
}

/** @deprecated */
export interface OptionOrderLeg extends OrderLeg {
    legType: "O";
    style: string;
    type: string;
    expiry: string;
    strike: number;
    daysToExpiry: number;
}

/** @deprecated */
export interface EquityOrderLeg extends OrderLeg {
    legType: "E";
    cvf: number;
}

/** @deprecated */
export interface CreatedBy {
    id: number;
    username: string;
    displayName: string;
}
